import { useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef } from 'react'

import { ScheduleNodeData } from '../../../converters/shared/reactFlowTypes'
import { withScheduleSelection } from './scheduleSelection'

/**
 * Hook for Schedule node functionality.
 * Handles schedule selection.
 */
export const useScheduleNode = (id: string, data: ScheduleNodeData) => {
  const { updateNodeData } = useReactFlow()
  const dataRef = useRef(data)

  // Keep dataRef in sync with data
  useEffect(() => {
    dataRef.current = data
  }, [data])

  const currentScheduleId = data.scheduleId || ''

  const handleScheduleChange = useCallback(
    (scheduleId: string | undefined, scheduleUuid: string | undefined) => {
      updateNodeData(
        id,
        withScheduleSelection(dataRef.current, scheduleId, scheduleUuid),
        { replace: true },
      )
    },
    [id, updateNodeData],
  )

  return {
    currentScheduleId,
    handleScheduleChange,
    hasData: !!currentScheduleId,
  }
}
